












import { Component, Vue } from 'vue-property-decorator'
import CalculateStore from '@/stores/CalculateStore'

@Component({ inheritAttrs: false })
export default class WeightField extends Vue {
  get weight(): null | number {
    return CalculateStore.weight
  }

  set weight(value: null | number) {
    CalculateStore.setWeight(value)
  }
}
